import { defaultHttpClient } from '../../httpClient';

export interface RedeemAllGoodsCouponResponse {
  member_coupons_count: number;
  /** 구버전 서버는 내려주지 않음. 호출부에서 전체 발급으로 간주한다. */
  redeemed_coupons?: number[];
}

export const postRedeemAllGoodsCoupon = (
  goodsSno: number,
  fixedCouponSno?: number,
) => {
  return defaultHttpClient
    .request<RedeemAllGoodsCouponResponse>({
      url: `/api/v2/goods/${goodsSno}/coupons/redeem/`,
      method: 'POST',
      data: fixedCouponSno
        ? { fixed_coupon_sno: fixedCouponSno }
        : undefined,
    })
    .then(result => result.data);
};
